import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import {
    CloseIconContainer,
    CloseIcon,
    HeaderContainer,
    HeaderDetails,
    HeaderSpan,
    AccountHeaderFont,
    AccountSubHeaderFont,
    FavouriteIcon,
    FavoriteIconContainer,
} from './physicianHeader.styled';
import { useTranslation } from 'react-i18next';
import {
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from 'src/pages/more/pages/accounts/components/AccountDetails/AccountHeader.styled';
import FavoriteActive from 'src/assets/images/FavoriteActive.svg';
import FavoriteInActive from 'src/assets/images/favorite-inactive.svg';
import BackIcon from 'src/assets/images/ArrowLeftLight.svg';
import {
    accountNumberZeroTrimmer,
    logErrorToConsole,
} from 'src/utils/util';
import { setFavoritePhysician } from 'src/pages/more/redux/actions';
import {
    CC_USER_ROLE,
    CSR_USER_ROLE,
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PhysicianDetailHeader = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { account, isFromAccount } = props;
    const physicianDropdownZGMorePhysicianVisibility = useSelector(
        (state) => state.loginReducer.physicianDropdownZGMorePhysicianVisibility
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    useEffectWithErrorLogging(() => {}, [account]);
    return (
        <>
            {' '}
            {isFromAccount ? (
                <BackButtonContainer
                    margin={'0'}
                    style={{ cursor: 'pointer', marginLeft: '-7px' }}
                >
                    <BackButtonIcon onClick={props.onClose} margin={'0 0 0 0px'} src={BackIcon} />
                    <BackText>
                        <a onClick={props.onClose}>
                            {t(
                                'physicians.physicianDetailsHeader.backToAccountDetails'
                            )}
                        </a>
                    </BackText>
                </BackButtonContainer>
            ) : null}
            <HeaderContainer>
                <HeaderDetails>
                    <AccountHeaderFont isDemi>
                        {props.isFromAccount && account.name}{' '}
                        {!props.isFromAccount && account.name}
                        {account.firstName} {account.lastName}
                    </AccountHeaderFont>
                    <HeaderSpan>
                    {physicianDropdownZGMorePhysicianVisibility === 'VISIBLE'?accountNumberZeroTrimmer(account.physicianId):account.hcpId}
                                        
                        {/* {account.hcpId} */}
                    </HeaderSpan>
                </HeaderDetails>
                {props.employeeRole !== CC_USER_ROLE &&
                    props.employeeRole !== FIA_USER_ROLE &&
                    props.employeeRole !== FIM_USER_ROLE &&
                    props.employeeRole !== ITA_USER_ROLE &&
                    props.employeeRole !== CSR_USER_ROLE && (
                        <FavoriteIconContainer value={physicianDropdownZGMorePhysicianVisibility === 'VISIBLE'?accountNumberZeroTrimmer(account.physicianId):account.hcpId}>
                            <FavouriteIcon
                                mobilePath={
                                    // isInstantFavorite
                                    account.isFavorite === true
                                        ? FavoriteActive
                                        : FavoriteInActive
                                }
                                onClick={() => {
                                    try {
                                        dispatch(
                                            setFavoritePhysician(
                                                account.physicianId,
                                                !account.isFavorite,
                                                '',
                                                isFromAccount,
                                                props.fromSearch
                                            )
                                        );
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            />
                        </FavoriteIconContainer>
                    )}
                {/* <CloseIconContainer>
                    <CloseIcon
                        mobilePath={Close}
                        onClick={props.onClose}
                        show={true}
                    />
                </CloseIconContainer> */}
            </HeaderContainer>
            <AccountSubHeaderFont isRegular>
                <span style={{ marginRight: '2px' }}>
                    {' '}
                    {account.city && account.city}
                    {account.city && account.state ? ',' : ''}{' '}
                    {account.state && account.state}{' '}
                </span>{' '}
                {account.specialty ? ' | ' : ''}{' '}
                <span style={{ marginLeft: '2px' }}>
                    {' '}
                    {isFromAccount && account.speciality}
                    {!isFromAccount && account.speciality}
                    {account.specialty}
                </span>
            </AccountSubHeaderFont>
        </>
    );
};

export default PhysicianDetailHeader;
